import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select } from "antd";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
const { Search } = Input;
const { Option } = Select;

export default class DoctorListView extends Component {
  render() {
    const {
      doctorList,
      allRecords,
      pageNo,
      onPageChange,
      searchText,
      handleSearchText,
      handleSearch,
      filterBy,
      handleFilterBy,
      navigateToDoctorDetails
    } = this.props;

    const columns = [
      {
        title: "Name",
        key: "name",
        align: "left",
        render: record => (
          <Link to={`/doctor-details/${record.id}/basic-details`}>
            {record.name || "--"}
          </Link>
        )
      },
      {
        title: "email",
        key: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "phone number",
        key: "phone_number",
        align: "left",
        render: record => <div>{record.phone_number || "--"}</div>
      },
      {
        title: "status",
        key: "status",
        align: "left",
        render: record => <div>{record.status || "--"}</div>
      },
      {
        title: "verified",
        key: "verified",
        align: "left",
        render: record => (
          <div>{record?.verified ? "Verified" : "Unverified"}</div>
        )
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.dashboard.doctor}
            </Col>
            <Col span={19}>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                gutter={50}
              >
                <Col span={12}>
                  <label>{strings.dashboard.searchBy}</label>
                  <Search
                    className="mt-7"
                    value={searchText}
                    onChange={handleSearchText}
                    placeholder={strings.dashboard.searchByDoctorPlaceholder}
                    onSearch={handleSearch}
                    onPressEnter={handleSearch}
                    allowClear
                  />
                </Col>
                <Col span={12}>
                  <div>
                    <label>{strings.dashboard.filterBy}</label>
                  </div>
                  <div>
                    <Select
                      defaultValue="all"
                      value={filterBy}
                      className="mt-7 filter-wrap-width"
                      placeholder={strings.dashboard.searchByStatePlaceholder}
                      onChange={handleFilterBy}
                    >
                      <Option value="">All</Option>
                      <Option value="joined">Joined</Option>
                      <Option value="invited">Invited</Option>
                      <Option value="verified">Verified</Option>
                      <Option value="unverified">Unverified</Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              // onRowClick={record => navigateToDoctorDetails(record.id)}
              columns={columns}
              dataSource={doctorList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={10}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
